import { useReactiveVar } from '@apollo/client';

import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';
import { sharedCoverLetterClientDocumentVariable } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

export const useReadCoverLetter = (): CoverLetterDocumentType => {
  return useReactiveVar(sharedCoverLetterClientDocumentVariable);
};
